import { iconInfoGlyph, iconInvalidGlyph, iconValidGlyph } from '@collectivehealth/dls-form-tokens/dist/dls-field-message-tokens.module.js';
import '@collectivehealth/dls-icon-label';
import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-check-small.js';
import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-circle-exclamation-small.js';
import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-lightbulb-small.js';
import { SvelteStyleStoreFactory, StyleUtilities, bubbleSlotchange, getCheckForSlottedChildren, getCheckForSlotted } from '@collectivehealth/dls-styles';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}
Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);

function noop() {}

function run(fn) {
  return fn();
}

function blank_object() {
  return Object.create(null);
}

function run_all(fns) {
  fns.forEach(run);
}

function is_function(thing) {
  return typeof thing === 'function';
}

function safe_not_equal(a, b) {
  return a != a ? b == b : a !== b || a && _typeof(a) === 'object' || typeof a === 'function';
}

function subscribe(store) {
  for (var _len = arguments.length, callbacks = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    callbacks[_key - 1] = arguments[_key];
  }

  var unsub = store.subscribe.apply(store, callbacks);
  return unsub.unsubscribe ? function () {
    return unsub.unsubscribe();
  } : unsub;
}

function component_subscribe(component, store, callback) {
  component.$$.on_destroy.push(subscribe(store, callback));
}

function append(target, node) {
  target.appendChild(node);
}

function insert(target, node, anchor) {
  target.insertBefore(node, anchor || null);
}

function detach(node) {
  node.parentNode.removeChild(node);
}

function element(name) {
  return document.createElement(name);
}

function text(data) {
  return document.createTextNode(data);
}

function space() {
  return text(' ');
}

function listen(node, event, handler, options) {
  node.addEventListener(event, handler, options);
  return function () {
    return node.removeEventListener(event, handler, options);
  };
}

function attr(node, attribute, value) {
  if (value == null) node.removeAttribute(attribute);else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
}

function set_custom_element_data(node, prop, value) {
  if (prop in node) {
    node[prop] = value;
  } else {
    attr(node, prop, value);
  }
}

function children(element) {
  return Array.from(element.childNodes);
}

function set_data(text, data) {
  data = '' + data;
  if (text.data !== data) text.data = data;
}

var current_component;

function set_current_component(component) {
  current_component = component;
}

function get_current_component() {
  if (!current_component) throw new Error("Function called outside component initialization");
  return current_component;
}

function onMount(fn) {
  get_current_component().$$.on_mount.push(fn);
}

var dirty_components = [];
var binding_callbacks = [];
var render_callbacks = [];
var flush_callbacks = [];
var resolved_promise = Promise.resolve();
var update_scheduled = false;

function schedule_update() {
  if (!update_scheduled) {
    update_scheduled = true;
    resolved_promise.then(flush);
  }
}

function add_render_callback(fn) {
  render_callbacks.push(fn);
}

function flush() {
  var seen_callbacks = new Set();

  do {
    // first, call beforeUpdate functions
    // and update components
    while (dirty_components.length) {
      var component = dirty_components.shift();
      set_current_component(component);
      update(component.$$);
    }

    while (binding_callbacks.length) {
      binding_callbacks.pop()();
    } // then, once components are updated, call
    // afterUpdate functions. This may cause
    // subsequent updates...


    for (var i = 0; i < render_callbacks.length; i += 1) {
      var callback = render_callbacks[i];

      if (!seen_callbacks.has(callback)) {
        callback(); // ...so guard against infinite loops

        seen_callbacks.add(callback);
      }
    }

    render_callbacks.length = 0;
  } while (dirty_components.length);

  while (flush_callbacks.length) {
    flush_callbacks.pop()();
  }

  update_scheduled = false;
}

function update($$) {
  if ($$.fragment !== null) {
    $$.update();
    run_all($$.before_update);
    var dirty = $$.dirty;
    $$.dirty = [-1];
    $$.fragment && $$.fragment.p($$.ctx, dirty);
    $$.after_update.forEach(add_render_callback);
  }
}

var outroing = new Set();

function transition_in(block, local) {
  if (block && block.i) {
    outroing.delete(block);
    block.i(local);
  }
}

function mount_component(component, target, anchor) {
  var _component$$$ = component.$$,
      fragment = _component$$$.fragment,
      on_mount = _component$$$.on_mount,
      on_destroy = _component$$$.on_destroy,
      after_update = _component$$$.after_update;
  fragment && fragment.m(target, anchor); // onMount happens before the initial afterUpdate

  add_render_callback(function () {
    var new_on_destroy = on_mount.map(run).filter(is_function);

    if (on_destroy) {
      on_destroy.push.apply(on_destroy, _toConsumableArray(new_on_destroy));
    } else {
      // Edge case - component was destroyed immediately,
      // most likely as a result of a binding initialising
      run_all(new_on_destroy);
    }

    component.$$.on_mount = [];
  });
  after_update.forEach(add_render_callback);
}

function destroy_component(component, detaching) {
  var $$ = component.$$;

  if ($$.fragment !== null) {
    run_all($$.on_destroy);
    $$.fragment && $$.fragment.d(detaching); // TODO null out other refs, including component.$$ (but need to
    // preserve final state?)

    $$.on_destroy = $$.fragment = null;
    $$.ctx = [];
  }
}

function make_dirty(component, i) {
  if (component.$$.dirty[0] === -1) {
    dirty_components.push(component);
    schedule_update();
    component.$$.dirty.fill(0);
  }

  component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}

function init(component, options, instance, create_fragment, not_equal, props) {
  var dirty = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [-1];
  var parent_component = current_component;
  set_current_component(component);
  var prop_values = options.props || {};
  var $$ = component.$$ = {
    fragment: null,
    ctx: null,
    // state
    props: props,
    update: noop,
    not_equal: not_equal,
    bound: blank_object(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    before_update: [],
    after_update: [],
    context: new Map(parent_component ? parent_component.$$.context : []),
    // everything else
    callbacks: blank_object(),
    dirty: dirty
  };
  var ready = false;
  $$.ctx = instance ? instance(component, prop_values, function (i, ret) {
    var value = (arguments.length <= 2 ? 0 : arguments.length - 2) ? arguments.length <= 2 ? undefined : arguments[2] : ret;

    if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
      if ($$.bound[i]) $$.bound[i](value);
      if (ready) make_dirty(component, i);
    }

    return ret;
  }) : [];
  $$.update();
  ready = true;
  run_all($$.before_update); // `false` as a special case of no DOM component

  $$.fragment = create_fragment ? create_fragment($$.ctx) : false;

  if (options.target) {
    if (options.hydrate) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.l(children(options.target));
    } else {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.c();
    }

    if (options.intro) transition_in(component.$$.fragment);
    mount_component(component, options.target, options.anchor);
    flush();
  }

  set_current_component(parent_component);
}

var SvelteElement;

if (typeof HTMLElement === 'function') {
  SvelteElement =
  /*#__PURE__*/
  function (_CustomElement2) {
    _inherits(SvelteElement, _CustomElement2);

    function SvelteElement() {
      var _this;

      _classCallCheck(this, SvelteElement);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(SvelteElement).call(this));

      _this.attachShadow({
        mode: 'open'
      });

      return _this;
    }

    _createClass(SvelteElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        // @ts-ignore todo: improve typings
        for (var key in this.$$.slotted) {
          // @ts-ignore todo: improve typings
          this.appendChild(this.$$.slotted[key]);
        }
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(attr, _oldValue, newValue) {
        this[attr] = newValue;
      }
    }, {
      key: "$destroy",
      value: function $destroy() {
        destroy_component(this, 1);
        this.$destroy = noop;
      }
    }, {
      key: "$on",
      value: function $on(type, callback) {
        // TODO should this delegate to addEventListener?
        var callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
        callbacks.push(callback);
        return function () {
          var index = callbacks.indexOf(callback);
          if (index !== -1) callbacks.splice(index, 1);
        };
      }
    }, {
      key: "$set",
      value: function $set() {// overridden by instance, if it has props
      }
    }]);

    return SvelteElement;
  }(_CustomElement);
}

var fieldMessage = {
    "dls-typography-desktop-body-reg-small": "mc03becab3_dls-typography-desktop-body-reg-small",
    "fieldMessage": "mc03becab3_dls-typography-desktop-body-reg-small mc03becab3_fieldMessage",
    "fieldMessageGlyph": "mc03becab3_fieldMessageGlyph",
    "info": "mc03becab3_info",
    "invalid": "mc03becab3_invalid",
    "valid": "mc03becab3_valid",
    "fieldMessageText": "mc03becab3_fieldMessageText"
};
var fieldMessage$1 = "mc03becab3_dls-typography-desktop-body-reg-small mc03becab3_fieldMessage";
var fieldMessageGlyph = "mc03becab3_fieldMessageGlyph";
var info = "mc03becab3_info";
var invalid = "mc03becab3_invalid";
var valid = "mc03becab3_valid";
var fieldMessageText = "mc03becab3_fieldMessageText";
var styles = ".mc03becab3_dls-typography-desktop-body-reg-small{font-family:Lab Grotesque,sans-serif;font-weight:400;text-transform:none;font-size:14px;letter-spacing:0;line-height:20px}:host{display:block}dls-field-message{display:block}[data-style]{display:none}.mc03becab3_fieldMessageGlyph{color:#706f6e;display:block;position:relative;top:1px}.mc03becab3_fieldMessageGlyph.mc03becab3_info{color:#566fb8}.mc03becab3_fieldMessageGlyph.mc03becab3_invalid{color:#f76056}.mc03becab3_fieldMessageGlyph.mc03becab3_valid{color:#7bc99d}.mc03becab3_fieldMessageText{color:#706f6e}.mc03becab3_fieldMessageText.mc03becab3_info{color:#706f6e}.mc03becab3_fieldMessageText.mc03becab3_invalid{color:#d1352a}.mc03becab3_fieldMessageText.mc03becab3_valid{color:#706f6e}";

var fieldMessageStyles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': fieldMessage,
  fieldMessage: fieldMessage$1,
  fieldMessageGlyph: fieldMessageGlyph,
  info: info,
  invalid: invalid,
  valid: valid,
  fieldMessageText: fieldMessageText,
  styles: styles
});

var fieldMessageStyleStore = SvelteStyleStoreFactory();
var subscribe$1 = fieldMessageStyleStore.subscribe,
    addStyles = fieldMessageStyleStore.addStyles;

function create_fragment(ctx) {
  var dls_icon_label;
  var div0;
  var t0;
  var slot0;
  var t1;
  var div1;
  var slot1;
  var t2;
  var slot2;
  var t3;
  var div1_class_value;
  var dls_icon_label_class_value;
  return {
    c: function c() {
      dls_icon_label = element("dls-icon-label");
      div0 = element("div");
      t0 = space();
      slot0 = element("slot");
      t1 = space();
      div1 = element("div");
      slot1 = element("slot");
      t2 = space();
      slot2 = element("slot");
      t3 = text(
      /*formattedText*/
      ctx[4]);
      this.c = noop;
      attr(div0, "data-style", "");
      attr(slot0, "name", "field-message-glyph");
      attr(slot0, "slot", "icon-label-glyph");
      attr(slot1, "name", "field-message-text");
      attr(div1, "class", div1_class_value = "" + (
      /*style*/
      ctx[7].is("fieldMessageText") + " " +
      /*style*/
      ctx[7].is(
      /*status*/
      ctx[1]) + " " +
      /*$altStyles*/
      ctx[5].part("theme/".concat(
      /*theme*/
      ctx[2], "/fieldMessageText"))));
      attr(div1, "slot", "icon-label-text");
      set_custom_element_data(dls_icon_label, "align", "top");
      set_custom_element_data(dls_icon_label, "class", dls_icon_label_class_value = "" + (
      /*style*/
      ctx[7].is("fieldMessage") + " " +
      /*$altStyles*/
      ctx[5].part("theme/".concat(
      /*theme*/
      ctx[2], "/fieldMessage"))));
      set_custom_element_data(dls_icon_label, "glyph",
      /*glyph*/
      ctx[0]);
      set_custom_element_data(dls_icon_label, "position", "left");
      set_custom_element_data(dls_icon_label, "space", "mini");
    },
    m: function m(target, anchor) {
      insert(target, dls_icon_label, anchor);
      append(dls_icon_label, div0);
      div0.innerHTML =
      /*stylesheet*/
      ctx[6];
      append(dls_icon_label, t0);
      append(dls_icon_label, slot0);
      slot0.innerHTML =
      /*formattedGlyph*/
      ctx[3];
      append(dls_icon_label, t1);
      append(dls_icon_label, div1);
      append(div1, slot1);
      append(div1, t2);
      append(div1, slot2);
      append(slot2, t3);
    },
    p: function p(ctx, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];

      if (dirty &
      /*formattedGlyph*/
      8) slot0.innerHTML =
      /*formattedGlyph*/
      ctx[3];
      if (dirty &
      /*formattedText*/
      16) set_data(t3,
      /*formattedText*/
      ctx[4]);

      if (dirty &
      /*status, $altStyles, theme*/
      38 && div1_class_value !== (div1_class_value = "" + (
      /*style*/
      ctx[7].is("fieldMessageText") + " " +
      /*style*/
      ctx[7].is(
      /*status*/
      ctx[1]) + " " +
      /*$altStyles*/
      ctx[5].part("theme/".concat(
      /*theme*/
      ctx[2], "/fieldMessageText"))))) {
        attr(div1, "class", div1_class_value);
      }

      if (dirty &
      /*$altStyles, theme*/
      36 && dls_icon_label_class_value !== (dls_icon_label_class_value = "" + (
      /*style*/
      ctx[7].is("fieldMessage") + " " +
      /*$altStyles*/
      ctx[5].part("theme/".concat(
      /*theme*/
      ctx[2], "/fieldMessage"))))) {
        set_custom_element_data(dls_icon_label, "class", dls_icon_label_class_value);
      }

      if (dirty &
      /*glyph*/
      1) {
        set_custom_element_data(dls_icon_label, "glyph",
        /*glyph*/
        ctx[0]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(dls_icon_label);
    }
  };
}

function instance($$self, $$props, $$invalidate) {
  var $altStyles;
  component_subscribe($$self, fieldMessageStyleStore, function ($$value) {
    return $$invalidate(5, $altStyles = $$value);
  });
  var stylesheet = "<style>".concat(styles, "</style>");
  var style = new StyleUtilities(fieldMessageStyles);
  var _$$props$glyph = $$props.glyph,
      glyph = _$$props$glyph === void 0 ? "" : _$$props$glyph;
  var _$$props$status = $$props.status,
      status = _$$props$status === void 0 ? "" : _$$props$status;
  var _$$props$text = $$props.text,
      text = _$$props$text === void 0 ? "" : _$$props$text;
  var _$$props$theme = $$props.theme,
      theme = _$$props$theme === void 0 ? "" : _$$props$theme;

  function getFormattedGlyph(glyph, status) {
    var glyphMap = {
      info: iconInfoGlyph,
      invalid: iconInvalidGlyph,
      valid: iconValidGlyph
    };

    if (Object.keys(glyphMap).indexOf(status) > -1) {
      glyph = glyphMap[status].replace("dls-icon-", "");
    }

    var glyphClassNames = style.are("fieldMessageGlyph", status);
    var hasGlyph = Boolean(glyph && typeof glyph === "string" && glyph.length);
    return hasGlyph ? "<dls-icon-".concat(glyph, " class=\"").concat(glyphClassNames, "\"></dls-icon-").concat(glyph, ">") : "";
  }

  $$self.$set = function ($$props) {
    if ("glyph" in $$props) $$invalidate(0, glyph = $$props.glyph);
    if ("status" in $$props) $$invalidate(1, status = $$props.status);
    if ("text" in $$props) $$invalidate(8, text = $$props.text);
    if ("theme" in $$props) $$invalidate(2, theme = $$props.theme);
  };

  var formattedGlyph;
  var hasText;
  var formattedText;

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*glyph, status*/
    3) {
       $$invalidate(3, formattedGlyph = getFormattedGlyph(glyph, status));
    }

    if ($$self.$$.dirty &
    /*text*/
    256) {
       $$invalidate(9, hasText = Boolean(text && typeof text === "string" && text.length));
    }

    if ($$self.$$.dirty &
    /*hasText, text*/
    768) {
       $$invalidate(4, formattedText = hasText ? text : "");
    }
  };

  return [glyph, status, theme, formattedGlyph, formattedText, $altStyles, stylesheet, style, text];
}

var DlsField =
/*#__PURE__*/
function (_SvelteElement) {
  _inherits(DlsField, _SvelteElement);

  function DlsField(options) {
    var _this;

    _classCallCheck(this, DlsField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DlsField).call(this));
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance, create_fragment, safe_not_equal, {
      glyph: 0,
      status: 1,
      text: 8,
      theme: 2
    });

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }

      if (options.props) {
        _this.$set(options.props);

        flush();
      }
    }

    return _this;
  }

  _createClass(DlsField, [{
    key: "glyph",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(glyph) {
      this.$set({
        glyph: glyph
      });
      flush();
    }
  }, {
    key: "status",
    get: function get() {
      return this.$$.ctx[1];
    },
    set: function set(status) {
      this.$set({
        status: status
      });
      flush();
    }
  }, {
    key: "text",
    get: function get() {
      return this.$$.ctx[8];
    },
    set: function set(text) {
      this.$set({
        text: text
      });
      flush();
    }
  }, {
    key: "theme",
    get: function get() {
      return this.$$.ctx[2];
    },
    set: function set(theme) {
      this.$set({
        theme: theme
      });
      flush();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["glyph", "status", "text", "theme"];
    }
  }]);

  return DlsField;
}(SvelteElement);

var field = {
    "dls-typography-desktop-body-bold-medium": "mc6d741512_dls-typography-desktop-body-bold-medium",
    "dls-typography-desktop-body-reg-small": "mc6d741512_dls-typography-desktop-body-reg-small",
    "dls-typography-desktop-uppercase-med-medium": "mc6d741512_dls-typography-desktop-uppercase-med-medium",
    "fieldLabel": "mc6d741512_fieldLabel",
    "_fieldLabelSlot": "mc6d741512__fieldLabelSlot",
    "isOptional": "mc6d741512_isOptional",
    "primary": "mc6d741512_dls-typography-desktop-body-bold-medium mc6d741512_primary",
    "secondary": "mc6d741512_dls-typography-desktop-uppercase-med-medium mc6d741512_secondary",
    "fieldOptional": "mc6d741512_dls-typography-desktop-body-reg-small mc6d741512_fieldOptional",
    "dls-typography-desktop-body-reg-medium": "mc6d741512_dls-typography-desktop-body-reg-medium",
    "field": "mc6d741512_field",
    "fieldDescription": "mc6d741512_dls-typography-desktop-body-reg-medium mc6d741512_fieldDescription",
    "empty": "mc6d741512_empty",
    "fieldControl": "mc6d741512_dls-typography-desktop-body-reg-medium mc6d741512_fieldControl",
    "fieldStatus": "mc6d741512_fieldStatus",
    "info": "mc6d741512_info",
    "hidestatus": "mc6d741512_hidestatus",
    "invalid": "mc6d741512_invalid",
    "valid": "mc6d741512_valid",
    "fieldMessage": "mc6d741512_dls-typography-desktop-body-reg-small mc6d741512_fieldMessage"
};
var fieldLabel = "mc6d741512_fieldLabel";
var _fieldLabelSlot = "mc6d741512__fieldLabelSlot";
var isOptional = "mc6d741512_isOptional";
var primary = "mc6d741512_dls-typography-desktop-body-bold-medium mc6d741512_primary";
var secondary = "mc6d741512_dls-typography-desktop-uppercase-med-medium mc6d741512_secondary";
var fieldOptional = "mc6d741512_dls-typography-desktop-body-reg-small mc6d741512_fieldOptional";
var field$1 = "mc6d741512_field";
var fieldDescription = "mc6d741512_dls-typography-desktop-body-reg-medium mc6d741512_fieldDescription";
var empty = "mc6d741512_empty";
var fieldControl = "mc6d741512_dls-typography-desktop-body-reg-medium mc6d741512_fieldControl";
var fieldStatus = "mc6d741512_fieldStatus";
var info$1 = "mc6d741512_info";
var hidestatus = "mc6d741512_hidestatus";
var invalid$1 = "mc6d741512_invalid";
var valid$1 = "mc6d741512_valid";
var fieldMessage$2 = "mc6d741512_dls-typography-desktop-body-reg-small mc6d741512_fieldMessage";
var styles$1 = ".mc6d741512_dls-typography-desktop-body-bold-medium{font-family:Lab Grotesque,sans-serif;font-weight:700;text-transform:none;font-size:16px;letter-spacing:0;line-height:24px}.mc6d741512_dls-typography-desktop-body-reg-small{font-family:Lab Grotesque,sans-serif;font-weight:400;text-transform:none;font-size:14px;letter-spacing:0;line-height:20px}.mc6d741512_dls-typography-desktop-uppercase-med-medium{font-family:Lab Grotesque,sans-serif;font-weight:500;text-transform:uppercase;font-size:12px;letter-spacing:1.399999976158142px;line-height:18px}.mc6d741512_fieldLabel{align-items:baseline;display:flex}.mc6d741512__fieldLabelSlot{flex:1 0 auto}.mc6d741512__fieldLabelSlot.mc6d741512_isOptional{flex:0 1 auto}.mc6d741512_primary{color:#3e3939}.mc6d741512_secondary{color:#706f6e}.mc6d741512_fieldOptional{color:#706f6e;display:none;margin-left:12px}.mc6d741512_fieldOptional.mc6d741512_isOptional{display:block}.mc6d741512_dls-typography-desktop-body-reg-medium{font-family:Lab Grotesque,sans-serif;font-weight:400;text-transform:none;font-size:16px;letter-spacing:0;line-height:24px}:host{display:block}dls-field{display:block}.mc6d741512_field{display:block}.mc6d741512_fieldDescription{color:#706f6e;margin-top:4px}.mc6d741512_fieldLabel.mc6d741512_empty+.mc6d741512_fieldDescription{margin-top:0}.mc6d741512_fieldControl{color:#3e3939;margin-top:8px}.mc6d741512_fieldLabel.mc6d741512_empty+.mc6d741512_fieldDescription.mc6d741512_empty+.mc6d741512_fieldControl{margin-top:0}.mc6d741512_fieldStatus{border-radius:0 0 2px 2px;display:block;height:5px;margin-top:-5px;position:relative;transition:transform .12s ease-out}.mc6d741512_fieldStatus,.mc6d741512_fieldStatus.mc6d741512_hidestatus,.mc6d741512_fieldStatus.mc6d741512_info,.mc6d741512_fieldStatus.mc6d741512_invalid.mc6d741512_hidestatus,.mc6d741512_fieldStatus.mc6d741512_valid.mc6d741512_hidestatus{transform:scaleX(0);transform-origin:center left}.mc6d741512_fieldStatus.mc6d741512_invalid{background-color:#f76056}.mc6d741512_fieldStatus.mc6d741512_valid{background-color:#7bc99d}.mc6d741512_fieldStatus.mc6d741512_invalid,.mc6d741512_fieldStatus.mc6d741512_valid{transform:scaleX(1)}.mc6d741512_fieldMessage{color:#706f6e;overflow-y:hidden;padding-top:8px;transition:max-height .24s ease-out .24s,opacity .24s ease-out .24s}.mc6d741512_fieldMessage.mc6d741512_info{transition-delay:0ms}.mc6d741512_fieldMessage.mc6d741512_empty{max-height:0;opacity:0}.mc6d741512_fieldMessage:not(.mc6d741512_empty){max-height:400px;opacity:1;transition-duration:.12s}[data-style]{display:none}.mc6d741512_empty{display:none}";

var fieldStyles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': field,
  fieldLabel: fieldLabel,
  _fieldLabelSlot: _fieldLabelSlot,
  isOptional: isOptional,
  primary: primary,
  secondary: secondary,
  fieldOptional: fieldOptional,
  field: field$1,
  fieldDescription: fieldDescription,
  empty: empty,
  fieldControl: fieldControl,
  fieldStatus: fieldStatus,
  info: info$1,
  hidestatus: hidestatus,
  invalid: invalid$1,
  valid: valid$1,
  fieldMessage: fieldMessage$2,
  styles: styles$1
});

var fieldStyleStore = SvelteStyleStoreFactory();
var subscribe$2 = fieldStyleStore.subscribe,
    addStyles$1 = fieldStyleStore.addStyles;

function create_if_block_4(ctx) {
  var slot;
  var t;
  var dispose;
  return {
    c: function c() {
      slot = element("slot");
      t = text(
      /*formattedLabel*/
      ctx[9]);
      attr(slot, "name", "field-label");
    },
    m: function m(target, anchor) {
      insert(target, slot, anchor);
      append(slot, t);
      dispose = listen(slot, "slotchange", bubbleSlotchange);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*formattedLabel*/
      512) set_data(t,
      /*formattedLabel*/
      ctx[9]);
    },
    d: function d(detaching) {
      if (detaching) detach(slot);
      dispose();
    }
  };
} // (19:4) {#if optional}


function create_if_block_3(ctx) {
  var div;
  var t;
  var div_class_value;
  return {
    c: function c() {
      div = element("div");
      t = text("Optional");
      attr(div, "class", div_class_value = "" + (
      /*style*/
      ctx[13].is("fieldOptional") + " " +
      /*style*/
      ctx[13].if("isOptional",
      /*optional*/
      ctx[1]) + " " +
      /*$altStyles*/
      ctx[11].part("theme/".concat(
      /*theme*/
      ctx[4], "/fieldOptional"))));
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      append(div, t);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*optional, $altStyles, theme*/
      2066 && div_class_value !== (div_class_value = "" + (
      /*style*/
      ctx[13].is("fieldOptional") + " " +
      /*style*/
      ctx[13].if("isOptional",
      /*optional*/
      ctx[1]) + " " +
      /*$altStyles*/
      ctx[11].part("theme/".concat(
      /*theme*/
      ctx[4], "/fieldOptional"))))) {
        attr(div, "class", div_class_value);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(div);
    }
  };
} // (31:4) {#if mounted}


function create_if_block_2(ctx) {
  var slot;
  var t;
  var dispose;
  return {
    c: function c() {
      slot = element("slot");
      t = text(
      /*formattedDescription*/
      ctx[8]);
      attr(slot, "name", "field-description");
    },
    m: function m(target, anchor) {
      insert(target, slot, anchor);
      append(slot, t);
      dispose = listen(slot, "slotchange", bubbleSlotchange);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*formattedDescription*/
      256) set_data(t,
      /*formattedDescription*/
      ctx[8]);
    },
    d: function d(detaching) {
      if (detaching) detach(slot);
      dispose();
    }
  };
} // (40:4) {#if mounted}


function create_if_block_1(ctx) {
  var slot0;
  var t;
  var slot1;
  var dispose;
  return {
    c: function c() {
      slot0 = element("slot");
      t = space();
      slot1 = element("slot");
      attr(slot0, "name", "field-control");
    },
    m: function m(target, anchor) {
      insert(target, slot0, anchor);
      insert(target, t, anchor);
      insert(target, slot1, anchor);
      dispose = [listen(slot0, "slotchange", bubbleSlotchange), listen(slot1, "slotchange", bubbleSlotchange)];
    },
    p: noop,
    d: function d(detaching) {
      if (detaching) detach(slot0);
      if (detaching) detach(t);
      if (detaching) detach(slot1);
      run_all(dispose);
    }
  };
} // (52:4) {#if mounted}


function create_if_block(ctx) {
  var slot;
  var dls_field_message;
  var dls_field_message_class_value;
  var dispose;
  return {
    c: function c() {
      slot = element("slot");
      dls_field_message = element("dls-field-message");
      set_custom_element_data(dls_field_message, "status",
      /*status*/
      ctx[3]);
      set_custom_element_data(dls_field_message, "text",
      /*formattedMessage*/
      ctx[10]);
      set_custom_element_data(dls_field_message, "class", dls_field_message_class_value =
      /*style*/
      ctx[13].if("empty", !
      /*hasMessage*/
      ctx[7]));
      attr(slot, "name", "field-message");
    },
    m: function m(target, anchor) {
      insert(target, slot, anchor);
      append(slot, dls_field_message);
      dispose = listen(slot, "slotchange", bubbleSlotchange);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*status*/
      8) {
        set_custom_element_data(dls_field_message, "status",
        /*status*/
        ctx[3]);
      }

      if (dirty &
      /*formattedMessage*/
      1024) {
        set_custom_element_data(dls_field_message, "text",
        /*formattedMessage*/
        ctx[10]);
      }

      if (dirty &
      /*hasMessage*/
      128 && dls_field_message_class_value !== (dls_field_message_class_value =
      /*style*/
      ctx[13].if("empty", !
      /*hasMessage*/
      ctx[7]))) {
        set_custom_element_data(dls_field_message, "class", dls_field_message_class_value);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(slot);
      dispose();
    }
  };
}

function create_fragment$1(ctx) {
  var div8;
  var div0;
  var t0;
  var div1;
  var raw1_value =
  /*$altStyles*/
  ctx[11].sheet("theme/".concat(
  /*theme*/
  ctx[4])) + "";
  var t1;
  var div3;
  var div2;
  var div2_class_value;
  var t2;
  var div3_class_value;
  var t3;
  var div4;
  var div4_class_value;
  var t4;
  var div5;
  var div5_class_value;
  var t5;
  var div6;
  var div6_class_value;
  var t6;
  var div7;
  var div7_class_value;
  var div8_class_value;
  var dispose;
  var if_block0 =
  /*mounted*/
  ctx[5] && create_if_block_4(ctx);
  var if_block1 =
  /*optional*/
  ctx[1] && create_if_block_3(ctx);
  var if_block2 =
  /*mounted*/
  ctx[5] && create_if_block_2(ctx);
  var if_block3 =
  /*mounted*/
  ctx[5] && create_if_block_1();
  var if_block4 =
  /*mounted*/
  ctx[5] && create_if_block(ctx);
  return {
    c: function c() {
      div8 = element("div");
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = space();
      div3 = element("div");
      div2 = element("div");
      if (if_block0) if_block0.c();
      t2 = space();
      if (if_block1) if_block1.c();
      t3 = space();
      div4 = element("div");
      if (if_block2) if_block2.c();
      t4 = space();
      div5 = element("div");
      if (if_block3) if_block3.c();
      t5 = space();
      div6 = element("div");
      t6 = space();
      div7 = element("div");
      if (if_block4) if_block4.c();
      this.c = noop;
      attr(div0, "data-style", "");
      attr(div1, "data-style", "");
      attr(div2, "class", div2_class_value = "" + (
      /*style*/
      ctx[13].is("_fieldLabelSlot") + " " +
      /*style*/
      ctx[13].if("isOptional",
      /*optional*/
      ctx[1])));
      attr(div3, "class", div3_class_value = "" + (
      /*style*/
      ctx[13].are("fieldLabel", "empty") + " " +
      /*style*/
      ctx[13].or("secondary", "primary",
      /*secondary*/
      ctx[2]) + " " +
      /*$altStyles*/
      ctx[11].part("theme/".concat(
      /*theme*/
      ctx[4], "/fieldLabel"))));
      attr(div4, "class", div4_class_value = "" + (
      /*style*/
      ctx[13].is("fieldDescription") + " " +
      /*style*/
      ctx[13].if("empty", !
      /*hasDescription*/
      ctx[6]) + " " +
      /*$altStyles*/
      ctx[11].part("theme/".concat(
      /*theme*/
      ctx[4], "/fieldDescription"))));
      attr(div5, "class", div5_class_value = "" + (
      /*style*/
      ctx[13].is("fieldControl") + " " +
      /*style*/
      ctx[13].is(
      /*status*/
      ctx[3]) + " " +
      /*$altStyles*/
      ctx[11].part("theme/".concat(
      /*theme*/
      ctx[4], "/fieldControl"))));
      attr(div6, "class", div6_class_value = "" + (
      /*style*/
      ctx[13].is("fieldStatus") + " " +
      /*style*/
      ctx[13].is(
      /*status*/
      ctx[3]) + " " +
      /*style*/
      ctx[13].if("hidestatus",
      /*hidestatus*/
      ctx[0]) + " " +
      /*$altStyles*/
      ctx[11].part("theme/".concat(
      /*theme*/
      ctx[4], "/fieldStatus"))));
      attr(div7, "class", div7_class_value = "" + (
      /*style*/
      ctx[13].is("fieldMessage") + " " +
      /*style*/
      ctx[13].is(
      /*status*/
      ctx[3]) + " " +
      /*style*/
      ctx[13].if("empty", !
      /*hasMessage*/
      ctx[7]) + " " +
      /*$altStyles*/
      ctx[11].part("theme/".concat(
      /*theme*/
      ctx[4], "/fieldMessage"))));
      attr(div8, "class", div8_class_value = "" + (
      /*style*/
      ctx[13].is("field") + " " +
      /*$altStyles*/
      ctx[11].part("theme/".concat(
      /*theme*/
      ctx[4], "/field"))));
    },
    m: function m(target, anchor) {
      insert(target, div8, anchor);
      append(div8, div0);
      div0.innerHTML =
      /*stylesheet*/
      ctx[12];
      append(div8, t0);
      append(div8, div1);
      div1.innerHTML = raw1_value;
      append(div8, t1);
      append(div8, div3);
      append(div3, div2);
      if (if_block0) if_block0.m(div2, null);
      append(div3, t2);
      if (if_block1) if_block1.m(div3, null);
      append(div8, t3);
      append(div8, div4);
      if (if_block2) if_block2.m(div4, null);
      append(div8, t4);
      append(div8, div5);
      if (if_block3) if_block3.m(div5, null);
      append(div8, t5);
      append(div8, div6);
      append(div8, t6);
      append(div8, div7);
      if (if_block4) if_block4.m(div7, null);
      dispose = [listen(div3, "slotchange",
      /*checkForSlotted*/
      ctx[14]), listen(div4, "slotchange",
      /*checkForSlotted*/
      ctx[14]), listen(div7, "slotchange",
      /*checkForSlotted*/
      ctx[14])];
    },
    p: function p(ctx, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];

      if (dirty &
      /*$altStyles, theme*/
      2064 && raw1_value !== (raw1_value =
      /*$altStyles*/
      ctx[11].sheet("theme/".concat(
      /*theme*/
      ctx[4])) + "")) div1.innerHTML = raw1_value;

      if (
      /*mounted*/
      ctx[5]) {
        if (if_block0) {
          if_block0.p(ctx, dirty);
        } else {
          if_block0 = create_if_block_4(ctx);
          if_block0.c();
          if_block0.m(div2, null);
        }
      } else if (if_block0) {
        if_block0.d(1);
        if_block0 = null;
      }

      if (dirty &
      /*optional*/
      2 && div2_class_value !== (div2_class_value = "" + (
      /*style*/
      ctx[13].is("_fieldLabelSlot") + " " +
      /*style*/
      ctx[13].if("isOptional",
      /*optional*/
      ctx[1])))) {
        attr(div2, "class", div2_class_value);
      }

      if (
      /*optional*/
      ctx[1]) {
        if (if_block1) {
          if_block1.p(ctx, dirty);
        } else {
          if_block1 = create_if_block_3(ctx);
          if_block1.c();
          if_block1.m(div3, null);
        }
      } else if (if_block1) {
        if_block1.d(1);
        if_block1 = null;
      }

      if (dirty &
      /*secondary, $altStyles, theme*/
      2068 && div3_class_value !== (div3_class_value = "" + (
      /*style*/
      ctx[13].are("fieldLabel", "empty") + " " +
      /*style*/
      ctx[13].or("secondary", "primary",
      /*secondary*/
      ctx[2]) + " " +
      /*$altStyles*/
      ctx[11].part("theme/".concat(
      /*theme*/
      ctx[4], "/fieldLabel"))))) {
        attr(div3, "class", div3_class_value);
      }

      if (
      /*mounted*/
      ctx[5]) {
        if (if_block2) {
          if_block2.p(ctx, dirty);
        } else {
          if_block2 = create_if_block_2(ctx);
          if_block2.c();
          if_block2.m(div4, null);
        }
      } else if (if_block2) {
        if_block2.d(1);
        if_block2 = null;
      }

      if (dirty &
      /*hasDescription, $altStyles, theme*/
      2128 && div4_class_value !== (div4_class_value = "" + (
      /*style*/
      ctx[13].is("fieldDescription") + " " +
      /*style*/
      ctx[13].if("empty", !
      /*hasDescription*/
      ctx[6]) + " " +
      /*$altStyles*/
      ctx[11].part("theme/".concat(
      /*theme*/
      ctx[4], "/fieldDescription"))))) {
        attr(div4, "class", div4_class_value);
      }

      if (
      /*mounted*/
      ctx[5]) {
        if (if_block3) {
          if_block3.p(ctx, dirty);
        } else {
          if_block3 = create_if_block_1();
          if_block3.c();
          if_block3.m(div5, null);
        }
      } else if (if_block3) {
        if_block3.d(1);
        if_block3 = null;
      }

      if (dirty &
      /*status, $altStyles, theme*/
      2072 && div5_class_value !== (div5_class_value = "" + (
      /*style*/
      ctx[13].is("fieldControl") + " " +
      /*style*/
      ctx[13].is(
      /*status*/
      ctx[3]) + " " +
      /*$altStyles*/
      ctx[11].part("theme/".concat(
      /*theme*/
      ctx[4], "/fieldControl"))))) {
        attr(div5, "class", div5_class_value);
      }

      if (dirty &
      /*status, hidestatus, $altStyles, theme*/
      2073 && div6_class_value !== (div6_class_value = "" + (
      /*style*/
      ctx[13].is("fieldStatus") + " " +
      /*style*/
      ctx[13].is(
      /*status*/
      ctx[3]) + " " +
      /*style*/
      ctx[13].if("hidestatus",
      /*hidestatus*/
      ctx[0]) + " " +
      /*$altStyles*/
      ctx[11].part("theme/".concat(
      /*theme*/
      ctx[4], "/fieldStatus"))))) {
        attr(div6, "class", div6_class_value);
      }

      if (
      /*mounted*/
      ctx[5]) {
        if (if_block4) {
          if_block4.p(ctx, dirty);
        } else {
          if_block4 = create_if_block(ctx);
          if_block4.c();
          if_block4.m(div7, null);
        }
      } else if (if_block4) {
        if_block4.d(1);
        if_block4 = null;
      }

      if (dirty &
      /*status, hasMessage, $altStyles, theme*/
      2200 && div7_class_value !== (div7_class_value = "" + (
      /*style*/
      ctx[13].is("fieldMessage") + " " +
      /*style*/
      ctx[13].is(
      /*status*/
      ctx[3]) + " " +
      /*style*/
      ctx[13].if("empty", !
      /*hasMessage*/
      ctx[7]) + " " +
      /*$altStyles*/
      ctx[11].part("theme/".concat(
      /*theme*/
      ctx[4], "/fieldMessage"))))) {
        attr(div7, "class", div7_class_value);
      }

      if (dirty &
      /*$altStyles, theme*/
      2064 && div8_class_value !== (div8_class_value = "" + (
      /*style*/
      ctx[13].is("field") + " " +
      /*$altStyles*/
      ctx[11].part("theme/".concat(
      /*theme*/
      ctx[4], "/field"))))) {
        attr(div8, "class", div8_class_value);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div8);
      if (if_block0) if_block0.d();
      if (if_block1) if_block1.d();
      if (if_block2) if_block2.d();
      if (if_block3) if_block3.d();
      if (if_block4) if_block4.d();
      run_all(dispose);
    }
  };
}

var safari14XRegex = /(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS)[ +]+(14)[_\.](\d+)|(Version\/14.1.\d+)/i;

function instance$1($$self, $$props, $$invalidate) {
  var $altStyles;
  component_subscribe($$self, fieldStyleStore, function ($$value) {
    return $$invalidate(11, $altStyles = $$value);
  });
  var stylesheet = "<style>".concat(styles$1, "</style>");
  var style = new StyleUtilities(fieldStyles);
  var checkForSlotted = getCheckForSlottedChildren(style.is("empty"));
  var _$$props$description = $$props.description,
      description = _$$props$description === void 0 ? "" : _$$props$description;
  var _$$props$hidestatus = $$props.hidestatus,
      hidestatus = _$$props$hidestatus === void 0 ? false : _$$props$hidestatus;
  var _$$props$label = $$props.label,
      label = _$$props$label === void 0 ? "" : _$$props$label;
  var _$$props$message = $$props.message,
      message = _$$props$message === void 0 ? "" : _$$props$message;
  var _$$props$optional = $$props.optional,
      optional = _$$props$optional === void 0 ? false : _$$props$optional;
  var _$$props$secondary = $$props.secondary,
      secondary = _$$props$secondary === void 0 ? false : _$$props$secondary;
  var _$$props$status = $$props.status,
      status = _$$props$status === void 0 ? "" : _$$props$status;
  var _$$props$theme = $$props.theme,
      theme = _$$props$theme === void 0 ? "" : _$$props$theme;
  var matchesSafari = navigator.userAgent.match(safari14XRegex);
  var mounted = matchesSafari === null;
  onMount(function () {
    if (!mounted) {
      setTimeout(function () {
        $$invalidate(5, mounted = true);
      }, 1);
    }
  });

  $$self.$set = function ($$props) {
    if ("description" in $$props) $$invalidate(15, description = $$props.description);
    if ("hidestatus" in $$props) $$invalidate(0, hidestatus = $$props.hidestatus);
    if ("label" in $$props) $$invalidate(16, label = $$props.label);
    if ("message" in $$props) $$invalidate(17, message = $$props.message);
    if ("optional" in $$props) $$invalidate(1, optional = $$props.optional);
    if ("secondary" in $$props) $$invalidate(2, secondary = $$props.secondary);
    if ("status" in $$props) $$invalidate(3, status = $$props.status);
    if ("theme" in $$props) $$invalidate(4, theme = $$props.theme);
  };

  var hasDescription;
  var hasLabel;
  var hasMessage;
  var hasStatus;
  var formattedDescription;
  var formattedLabel;
  var formattedMessage;

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*description*/
    32768) {
       $$invalidate(6, hasDescription = Boolean(description && typeof description === "string" && description.length));
    }

    if ($$self.$$.dirty &
    /*label*/
    65536) {
       $$invalidate(18, hasLabel = Boolean(label && typeof label === "string" && label.length));
    }

    if ($$self.$$.dirty &
    /*message*/
    131072) {
       $$invalidate(7, hasMessage = Boolean(message && typeof message === "string" && message.length));
    }

    if ($$self.$$.dirty &
    /*status*/
    8) {
       hasStatus = Boolean(status && typeof status === "string" && status.length);
    }

    if ($$self.$$.dirty &
    /*hasDescription, description*/
    32832) {
       $$invalidate(8, formattedDescription = hasDescription ? description : "");
    }

    if ($$self.$$.dirty &
    /*hasLabel, label*/
    327680) {
       $$invalidate(9, formattedLabel = hasLabel ? label : "");
    }

    if ($$self.$$.dirty &
    /*hasMessage, message*/
    131200) {
       $$invalidate(10, formattedMessage = hasMessage ? message : "");
    }
  };

  return [hidestatus, optional, secondary, status, theme, mounted, hasDescription, hasMessage, formattedDescription, formattedLabel, formattedMessage, $altStyles, stylesheet, style, checkForSlotted, description, label, message];
}

var DlsField$1 =
/*#__PURE__*/
function (_SvelteElement) {
  _inherits(DlsField, _SvelteElement);

  function DlsField(options) {
    var _this;

    _classCallCheck(this, DlsField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DlsField).call(this));
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance$1, create_fragment$1, safe_not_equal, {
      description: 15,
      hidestatus: 0,
      label: 16,
      message: 17,
      optional: 1,
      secondary: 2,
      status: 3,
      theme: 4
    });

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }

      if (options.props) {
        _this.$set(options.props);

        flush();
      }
    }

    return _this;
  }

  _createClass(DlsField, [{
    key: "description",
    get: function get() {
      return this.$$.ctx[15];
    },
    set: function set(description) {
      this.$set({
        description: description
      });
      flush();
    }
  }, {
    key: "hidestatus",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(hidestatus) {
      this.$set({
        hidestatus: hidestatus
      });
      flush();
    }
  }, {
    key: "label",
    get: function get() {
      return this.$$.ctx[16];
    },
    set: function set(label) {
      this.$set({
        label: label
      });
      flush();
    }
  }, {
    key: "message",
    get: function get() {
      return this.$$.ctx[17];
    },
    set: function set(message) {
      this.$set({
        message: message
      });
      flush();
    }
  }, {
    key: "optional",
    get: function get() {
      return this.$$.ctx[1];
    },
    set: function set(optional) {
      this.$set({
        optional: optional
      });
      flush();
    }
  }, {
    key: "secondary",
    get: function get() {
      return this.$$.ctx[2];
    },
    set: function set(secondary) {
      this.$set({
        secondary: secondary
      });
      flush();
    }
  }, {
    key: "status",
    get: function get() {
      return this.$$.ctx[3];
    },
    set: function set(status) {
      this.$set({
        status: status
      });
      flush();
    }
  }, {
    key: "theme",
    get: function get() {
      return this.$$.ctx[4];
    },
    set: function set(theme) {
      this.$set({
        theme: theme
      });
      flush();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["description", "hidestatus", "label", "message", "optional", "secondary", "status", "theme"];
    }
  }]);

  return DlsField;
}(SvelteElement);

var fieldset = {
    "dls-typography-desktop-body-bold-medium": "mc5d89db93_dls-typography-desktop-body-bold-medium",
    "dls-typography-desktop-body-reg-small": "mc5d89db93_dls-typography-desktop-body-reg-small",
    "dls-typography-desktop-uppercase-med-medium": "mc5d89db93_dls-typography-desktop-uppercase-med-medium",
    "fieldLabel": "mc5d89db93_fieldLabel",
    "_fieldLabelSlot": "mc5d89db93__fieldLabelSlot",
    "isOptional": "mc5d89db93_isOptional",
    "primary": "mc5d89db93_dls-typography-desktop-body-bold-medium mc5d89db93_primary",
    "secondary": "mc5d89db93_dls-typography-desktop-uppercase-med-medium mc5d89db93_secondary",
    "fieldOptional": "mc5d89db93_dls-typography-desktop-body-reg-small mc5d89db93_fieldOptional",
    "fieldset": "mc5d89db93_fieldset",
    "fieldsetLegend": "mc5d89db93_fieldLabel mc5d89db93_fieldsetLegend",
    "fieldsetControl": "mc5d89db93_fieldsetControl",
    "empty": "mc5d89db93_empty"
};
var fieldLabel$1 = "mc5d89db93_fieldLabel";
var _fieldLabelSlot$1 = "mc5d89db93__fieldLabelSlot";
var isOptional$1 = "mc5d89db93_isOptional";
var primary$1 = "mc5d89db93_dls-typography-desktop-body-bold-medium mc5d89db93_primary";
var secondary$1 = "mc5d89db93_dls-typography-desktop-uppercase-med-medium mc5d89db93_secondary";
var fieldOptional$1 = "mc5d89db93_dls-typography-desktop-body-reg-small mc5d89db93_fieldOptional";
var fieldset$1 = "mc5d89db93_fieldset";
var fieldsetLegend = "mc5d89db93_fieldLabel mc5d89db93_fieldsetLegend";
var fieldsetControl = "mc5d89db93_fieldsetControl";
var empty$1 = "mc5d89db93_empty";
var styles$2 = ".mc5d89db93_dls-typography-desktop-body-bold-medium{font-family:Lab Grotesque,sans-serif;font-weight:700;text-transform:none;font-size:16px;letter-spacing:0;line-height:24px}.mc5d89db93_dls-typography-desktop-body-reg-small{font-family:Lab Grotesque,sans-serif;font-weight:400;text-transform:none;font-size:14px;letter-spacing:0;line-height:20px}.mc5d89db93_dls-typography-desktop-uppercase-med-medium{font-family:Lab Grotesque,sans-serif;font-weight:500;text-transform:uppercase;font-size:12px;letter-spacing:1.399999976158142px;line-height:18px}.mc5d89db93_fieldLabel{align-items:baseline;display:flex}.mc5d89db93__fieldLabelSlot{flex:1 0 auto}.mc5d89db93__fieldLabelSlot.mc5d89db93_isOptional{flex:0 1 auto}.mc5d89db93_primary{color:#3e3939}.mc5d89db93_secondary{color:#706f6e}.mc5d89db93_fieldOptional{color:#706f6e;display:none;margin-left:12px}.mc5d89db93_fieldOptional.mc5d89db93_isOptional{display:block}.mc5d89db93_fieldset{border:0;margin:0;padding:0}.mc5d89db93_fieldsetLegend{padding:0}.mc5d89db93_fieldsetControl{padding-top:8px}.mc5d89db93_empty{display:none}";

var fieldsetStyles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': fieldset,
  fieldLabel: fieldLabel$1,
  _fieldLabelSlot: _fieldLabelSlot$1,
  isOptional: isOptional$1,
  primary: primary$1,
  secondary: secondary$1,
  fieldOptional: fieldOptional$1,
  fieldset: fieldset$1,
  fieldsetLegend: fieldsetLegend,
  fieldsetControl: fieldsetControl,
  empty: empty$1,
  styles: styles$2
});

var fieldsetStyleStore = SvelteStyleStoreFactory();
var subscribe$3 = fieldsetStyleStore.subscribe,
    addStyles$2 = fieldsetStyleStore.addStyles;

function create_fragment$2(ctx) {
  var fieldset;
  var legend_1;
  var div0;
  var slot0;
  var t0;
  var div0_class_value;
  var t1;
  var div1;
  var t2;
  var div1_class_value;
  var legend_1_class_value;
  var t3;
  var dls_field;
  var slot1;
  var t4;
  var t5;
  var div2;
  var slot2;
  var t6;
  var slot3;
  var div2_class_value;
  var t7;
  var slot4;
  var t8;
  var div3;
  var t9;
  var div4;
  var raw1_value =
  /*$altStyles*/
  ctx[5].sheet("theme/".concat(
  /*theme*/
  ctx[2])) + "";
  var fieldset_class_value;
  var dispose;
  return {
    c: function c() {
      fieldset = element("fieldset");
      legend_1 = element("legend");
      div0 = element("div");
      slot0 = element("slot");
      t0 = text(
      /*formattedLegend*/
      ctx[4]);
      t1 = space();
      div1 = element("div");
      t2 = text("Optional");
      t3 = space();
      dls_field = element("dls-field");
      slot1 = element("slot");
      t4 = text(
      /*formattedDescription*/
      ctx[3]);
      t5 = space();
      div2 = element("div");
      slot2 = element("slot");
      t6 = space();
      slot3 = element("slot");
      t7 = space();
      slot4 = element("slot");
      t8 = space();
      div3 = element("div");
      t9 = space();
      div4 = element("div");
      this.c = noop;
      attr(slot0, "name", "fieldset-legend");
      attr(div0, "class", div0_class_value = "" + (
      /*style*/
      ctx[7].is("_fieldsetLegendSlot") + " " +
      /*style*/
      ctx[7].if("isOptional",
      /*optional*/
      ctx[0]) + " " +
      /*style*/
      ctx[7].is("empty")));
      attr(div1, "class", div1_class_value = "" + (
      /*style*/
      ctx[7].is("fieldOptional") + " " +
      /*style*/
      ctx[7].if("isOptional",
      /*optional*/
      ctx[0]) + " " +
      /*$altStyles*/
      ctx[5].part("theme/".concat(
      /*theme*/
      ctx[2], "/fieldsetOptional"))));
      attr(legend_1, "class", legend_1_class_value = "" + (
      /*style*/
      ctx[7].is("fieldsetLegend") + " " +
      /*style*/
      ctx[7].is("primary") + " " +
      /*$altStyles*/
      ctx[5].part("theme/".concat(
      /*theme*/
      ctx[2], "/fieldsetLegend"))));
      attr(slot1, "name", "fieldset-description");
      attr(slot1, "slot", "field-description");
      attr(slot2, "name", "fieldset-control");
      attr(slot2, "slot", "field-control");
      attr(div2, "class", div2_class_value =
      /*style*/
      ctx[7].is("fieldsetControl"));
      attr(slot4, "name", "fieldset-message");
      attr(slot4, "slot", "field-message");
      set_custom_element_data(dls_field, "hidestatus", hidestatus$1);
      set_custom_element_data(dls_field, "status",
      /*status*/
      ctx[1]);
      set_custom_element_data(dls_field, "theme",
      /*theme*/
      ctx[2]);
      attr(div3, "data-style", "");
      attr(div4, "data-style", "");
      attr(fieldset, "class", fieldset_class_value = "" + (
      /*style*/
      ctx[7].is("fieldset") + " " +
      /*$altStyles*/
      ctx[5].part("theme/".concat(
      /*theme*/
      ctx[2], "/fieldset"))));
    },
    m: function m(target, anchor) {
      insert(target, fieldset, anchor);
      append(fieldset, legend_1);
      append(legend_1, div0);
      append(div0, slot0);
      append(slot0, t0);
      append(legend_1, t1);
      append(legend_1, div1);
      append(div1, t2);
      append(fieldset, t3);
      append(fieldset, dls_field);
      append(dls_field, slot1);
      append(slot1, t4);
      append(dls_field, t5);
      append(dls_field, div2);
      append(div2, slot2);
      append(div2, t6);
      append(div2, slot3);
      append(dls_field, t7);
      append(dls_field, slot4);
      append(fieldset, t8);
      append(fieldset, div3);
      div3.innerHTML =
      /*stylesheet*/
      ctx[6];
      append(fieldset, t9);
      append(fieldset, div4);
      div4.innerHTML = raw1_value;
      dispose = listen(slot0, "slotchange",
      /*checkForSlotted*/
      ctx[8]);
    },
    p: function p(ctx, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];

      if (dirty &
      /*formattedLegend*/
      16) set_data(t0,
      /*formattedLegend*/
      ctx[4]);

      if (dirty &
      /*optional*/
      1 && div0_class_value !== (div0_class_value = "" + (
      /*style*/
      ctx[7].is("_fieldsetLegendSlot") + " " +
      /*style*/
      ctx[7].if("isOptional",
      /*optional*/
      ctx[0]) + " " +
      /*style*/
      ctx[7].is("empty")))) {
        attr(div0, "class", div0_class_value);
      }

      if (dirty &
      /*optional, $altStyles, theme*/
      37 && div1_class_value !== (div1_class_value = "" + (
      /*style*/
      ctx[7].is("fieldOptional") + " " +
      /*style*/
      ctx[7].if("isOptional",
      /*optional*/
      ctx[0]) + " " +
      /*$altStyles*/
      ctx[5].part("theme/".concat(
      /*theme*/
      ctx[2], "/fieldsetOptional"))))) {
        attr(div1, "class", div1_class_value);
      }

      if (dirty &
      /*$altStyles, theme*/
      36 && legend_1_class_value !== (legend_1_class_value = "" + (
      /*style*/
      ctx[7].is("fieldsetLegend") + " " +
      /*style*/
      ctx[7].is("primary") + " " +
      /*$altStyles*/
      ctx[5].part("theme/".concat(
      /*theme*/
      ctx[2], "/fieldsetLegend"))))) {
        attr(legend_1, "class", legend_1_class_value);
      }

      if (dirty &
      /*formattedDescription*/
      8) set_data(t4,
      /*formattedDescription*/
      ctx[3]);

      if (dirty &
      /*status*/
      2) {
        set_custom_element_data(dls_field, "status",
        /*status*/
        ctx[1]);
      }

      if (dirty &
      /*theme*/
      4) {
        set_custom_element_data(dls_field, "theme",
        /*theme*/
        ctx[2]);
      }

      if (dirty &
      /*$altStyles, theme*/
      36 && raw1_value !== (raw1_value =
      /*$altStyles*/
      ctx[5].sheet("theme/".concat(
      /*theme*/
      ctx[2])) + "")) div4.innerHTML = raw1_value;

      if (dirty &
      /*$altStyles, theme*/
      36 && fieldset_class_value !== (fieldset_class_value = "" + (
      /*style*/
      ctx[7].is("fieldset") + " " +
      /*$altStyles*/
      ctx[5].part("theme/".concat(
      /*theme*/
      ctx[2], "/fieldset"))))) {
        attr(fieldset, "class", fieldset_class_value);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(fieldset);
      dispose();
    }
  };
}

var hidestatus$1 = true;

function instance$2($$self, $$props, $$invalidate) {
  var $altStyles;
  component_subscribe($$self, fieldsetStyleStore, function ($$value) {
    return $$invalidate(5, $altStyles = $$value);
  });
  var stylesheet = "<style>".concat(styles$2, "</style>");
  var style = new StyleUtilities(fieldsetStyles);
  var checkForSlotted = getCheckForSlotted(style.is("empty"));
  var _$$props$description = $$props.description,
      description = _$$props$description === void 0 ? "" : _$$props$description;
  var _$$props$legend = $$props.legend,
      legend = _$$props$legend === void 0 ? "" : _$$props$legend;
  var _$$props$optional = $$props.optional,
      optional = _$$props$optional === void 0 ? false : _$$props$optional;
  var _$$props$status = $$props.status,
      status = _$$props$status === void 0 ? "" : _$$props$status;
  var _$$props$theme = $$props.theme,
      theme = _$$props$theme === void 0 ? "" : _$$props$theme;

  $$self.$set = function ($$props) {
    if ("description" in $$props) $$invalidate(9, description = $$props.description);
    if ("legend" in $$props) $$invalidate(10, legend = $$props.legend);
    if ("optional" in $$props) $$invalidate(0, optional = $$props.optional);
    if ("status" in $$props) $$invalidate(1, status = $$props.status);
    if ("theme" in $$props) $$invalidate(2, theme = $$props.theme);
  };

  var hasDescription;
  var hasLegend;
  var formattedDescription;
  var formattedLegend;

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*description*/
    512) {
       $$invalidate(11, hasDescription = Boolean(description && typeof description === "string" && description.length));
    }

    if ($$self.$$.dirty &
    /*legend*/
    1024) {
       $$invalidate(12, hasLegend = Boolean(legend && typeof legend === "string" && legend.length));
    }

    if ($$self.$$.dirty &
    /*hasDescription, description*/
    2560) {
       $$invalidate(3, formattedDescription = hasDescription ? description : "");
    }

    if ($$self.$$.dirty &
    /*hasLegend, legend*/
    5120) {
       $$invalidate(4, formattedLegend = hasLegend ? legend : "");
    }
  };

  return [optional, status, theme, formattedDescription, formattedLegend, $altStyles, stylesheet, style, checkForSlotted, description, legend];
}

var DlsField$2 =
/*#__PURE__*/
function (_SvelteElement) {
  _inherits(DlsField, _SvelteElement);

  function DlsField(options) {
    var _this;

    _classCallCheck(this, DlsField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DlsField).call(this));
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance$2, create_fragment$2, safe_not_equal, {
      description: 9,
      legend: 10,
      optional: 0,
      status: 1,
      theme: 2
    });

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }

      if (options.props) {
        _this.$set(options.props);

        flush();
      }
    }

    return _this;
  }

  _createClass(DlsField, [{
    key: "description",
    get: function get() {
      return this.$$.ctx[9];
    },
    set: function set(description) {
      this.$set({
        description: description
      });
      flush();
    }
  }, {
    key: "legend",
    get: function get() {
      return this.$$.ctx[10];
    },
    set: function set(legend) {
      this.$set({
        legend: legend
      });
      flush();
    }
  }, {
    key: "optional",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(optional) {
      this.$set({
        optional: optional
      });
      flush();
    }
  }, {
    key: "status",
    get: function get() {
      return this.$$.ctx[1];
    },
    set: function set(status) {
      this.$set({
        status: status
      });
      flush();
    }
  }, {
    key: "theme",
    get: function get() {
      return this.$$.ctx[2];
    },
    set: function set(theme) {
      this.$set({
        theme: theme
      });
      flush();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["description", "legend", "optional", "status", "theme"];
    }
  }]);

  return DlsField;
}(SvelteElement);

var elements = [{
  tagName: 'dls-field',
  customElement: DlsField$1
}, {
  tagName: 'dls-field-message',
  customElement: DlsField
}, {
  tagName: 'dls-fieldset',
  customElement: DlsField$2
}];
elements.forEach(function (_ref) {
  var tagName = _ref.tagName,
      customElement = _ref.customElement;

  // TODO: create shared utility later
  // TODO: don't call by default later, will be breaking change
  try {
    window.customElements.define(tagName, customElement);
  } catch (error) {// TODO: See https://github.com/collectivehealth/dls/issues/552
  }
});

export { DlsField$1 as DlsField, DlsField as DlsFieldMessage, DlsField$2 as DlsFieldset, addStyles as addFieldMessageStyles, addStyles$1 as addFieldStyles, addStyles$2 as addFieldsetStyles };
